import React, { useRef, useState } from "react";
import { useSlateStatic, ReactEditor } from "slate-react";
import { Transforms } from "slate";
import FloatingBlockSettings from "../toolbar/buttons/blockSettings";

export const LayoutElement = ({ attributes, children }) => {
  return (
    <div
      {...attributes}
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        margin: "1rem 0"
      }}
    >
      {children}
    </div>
  );
};

export const LayoutRowElement = ({ attributes, children }) => {
  return (
    <div {...attributes} style={{ display: "flex", gap: "8px" }}>
      {children}
    </div>
  );
};

export const LayoutColElement = ({ attributes, children, element }) => {
  const editor = useSlateStatic();
  const [width, setWidth] = useState(element.width || 200);
  const [height, setHeight] = useState(element.height || 120);
  const requestRef = useRef(null);
  
  const startXRef = useRef(0);
  const startYRef = useRef(0);
  const startWidthRef = useRef(0);
  const startHeightRef = useRef(0);
  
  const handleResize = (newWidth, newHeight) => {
    const path = ReactEditor.findPath(editor, element);
    Transforms.setNodes(
      editor,
      { width: newWidth, height: newHeight },
      { at: path }
    );
  };
  
  const handleMouseDown = (event, resizeType) => {
    event.preventDefault();
    startXRef.current = event.clientX;
    startYRef.current = event.clientY;
    startWidthRef.current = width;
    startHeightRef.current = height;
  
    const handleMouseMove = (e) => {
      const dx = e.clientX - startXRef.current;
      const dy = e.clientY - startYRef.current;
  
      const newWidth = Math.max(100, startWidthRef.current + dx);
      const newHeight = Math.max(60, startHeightRef.current + dy);
  
      if (!requestRef.current) {
        requestRef.current = requestAnimationFrame(() => {
          if (resizeType === "both" || resizeType === "width") setWidth(newWidth);
          if (resizeType === "both" || resizeType === "height") setHeight(newHeight);
          handleResize(newWidth, newHeight);
          requestRef.current = null;
        });
      }
    };
  
    const handleMouseUp = () => {
      cancelAnimationFrame(requestRef.current);
      requestRef.current = null;
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };
  
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };
  
  return (
    <div
      {...attributes}
      style={{
        position: "relative",
        width,
        height,
        border: "1px solid #d9d9d9",
        padding: "8px",
        backgroundColor: "#fafafa",
        boxSizing: "border-box",
        resize: "none",
        overflow: "auto"
      }}
    >
      <FloatingBlockSettings element={element} />

      {children}
  
      {/* Right edge resizer for width */}
      <div
        onMouseDown={(e) => handleMouseDown(e, "width")}
        style={{
          position: "absolute",
          top: 0,
          right: 0,
          width: "1px",
          height: "100%",
          cursor: "col-resize",
          backgroundColor: "#ccc"
        }}
      />
  
      {/* Bottom edge resizer for height */}
      <div
        onMouseDown={(e) => handleMouseDown(e, "height")}
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          width: "100%",
          height: "1px",
          cursor: "row-resize",
          backgroundColor: "#ccc"
        }}
      />
  
      {/* Bottom-right corner resizer for both */}
      <div
        onMouseDown={(e) => handleMouseDown(e, "both")}
        style={{
          position: "absolute",
          bottom: 0,
          right: 0,
          width: "10px",
          height: "10px",
          cursor: "nwse-resize",
          backgroundColor: "#888"
        }}
      />
    </div>
  );
};
